import './styles/element-variables.scss'
import Vue from 'vue'
import store from './store'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
// import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'

import Secure from './Secure.vue'
import Sales from './pages/Sales.vue'
import Login from './Login.vue'

Vue.config.devtools = false // TODO: remove
Vue.use(VueRouter)
Vue.use(ElementUI, { locale })

const routes = [
  { path: '/login', name: 'auth', component: Login },
  {
    path: '/',
    component: Secure,
    children: [
      {
        path: '/',
        name: 'sales',
        component: Sales
      },
    ]
  },
]

const router = new VueRouter({
  routes
})

new Vue({
  store,
  router,
  el: '#app',
  render: h => h(App)
})
